export const loadHTML = (storagePath, id, beforeFunc, successFunc, failedFunc) => {
    return (dispatch, getState, getFirebase) => {
        if(beforeFunc) beforeFunc();

        const firebase = getFirebase();
        const htmlRef = firebase.storage().ref(`${storagePath}/${id}.html`);
        htmlRef.getDownloadURL()
            .then(url => {
                if(successFunc) successFunc(url);
            })
            .catch(e => {
                if(failedFunc) failedFunc(e);
            })
    }
}

export const deleteHTML = (textStoragePath, 
                            imageStoragePath, 
                            id, 
                            imageCount) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const htmlRef = firebase.storage().ref(`${textStoragePath}/${id}.html`);
        htmlRef.delete()
            .then(() => {
            })
            .catch((e) => {
            })
            
        for(let i = 0; i < imageCount; ++i) {
            const imageRef = firebase.storage().ref(`${imageStoragePath}/${id}_${i}.jpg`);
            imageRef.delete();
        }
    }
}

export const updateHTML = (storagePath, id, texts, successFunc, failedFunc) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const htmlRef = firebase.storage().ref(`${storagePath}/${id}.html`);    
        htmlRef.delete()
            .then(() => {
                const task = htmlRef.putString(texts);
                task.on('state_changed', 
                    (snapshot) => {
                        // const percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    },
                    (e) => { 
                        if(failedFunc) failedFunc(e);
                    },
                    ()=>{ 
                        if(successFunc) successFunc();
                    }
                )
            })
            .catch((e) => {
                const task = htmlRef.putString(texts);
                task.on('state_changed', 
                    (snapshot) => {
                        // const percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    },
                    (e) => { 
                        if(failedFunc) failedFunc(e);
                    },
                    ()=>{ 
                        if(successFunc) successFunc(); 
                    }
                )
            })
    }
}



// WEBPACK FOOTER //
// ./src/pages/Admin/actions/htmlActions.js